import { Component, EventEmitter, Input, inject, Output } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { SharedModule } from '@shared/modules/shared.module';
import { FileIconComponent, FileType } from '../file-icon/file-icon.component';

@Component({
	selector: 'app-file-item',
	imports: [SharedModule, FileIconComponent],
	templateUrl: './file-item.component.html',
	styleUrl: './file-item.component.scss',
})
export class FileItemComponent {
	private readonly translocoService = inject(TranslocoService);

	@Input() fileName = this.translocoService.translate('fileUpload.attachedFile');
	@Input() fileSize = 500;
	@Input() fileUrl?: string;
	@Input() fileType?: FileType;
	@Input() downloadable = true;
	@Input() action: 'download' | 'delete' = 'download';

	@Output() download = new EventEmitter<void>();
	@Output() remove = new EventEmitter<void>();

	triggerAction() {
		if (this.action === 'download') {
			this.download.emit();
		} else {
			this.remove.emit();
		}
	}

	getActionIcon(): string {
		return this.action === 'download' ? 'Download' : 'Trash2';
	}

	formatFileSize(size: number): string {
		return size < 1024
			? `${size} B`
			: size < 1048576
				? `${(size / 1024).toFixed(1)} KB`
				: `${(size / 1048576).toFixed(1)} MB`;
	}

	triggerDownload() {
		this.download.emit();
	}

	triggerRemove() {
		this.remove.emit();
	}
}
